const moment = require('moment');

function dateToLocal(date) {
  return moment.utc(date).local(false);
}

module.exports = {
  "displayDateFormat": "MM/DD/YYYY",
  "backendDateFormat": "YYYY-MM-DDTHH:mm:ssZ",
  "dateToLocal": dateToLocal,
};